import { useStore } from '~/store/store'
import { Department, Speciality, useDepartments } from '~/storm'
import { useAssignableSpecialities } from '~/storm/common/specialty'

export type ActiveDepartmentResolution =
    | { status: 'none' }
    | { status: 'resolved'; department: Department; specialities: Speciality[] }
    | { status: 'invalid'; departments: Department[] }
    | { status: 'all' }

export const useResolvedDepartmentByActiveSpecialities = (): ActiveDepartmentResolution => {
    const selectedSpecialties = useStore(state => state.appFilters.selectedSpecialties)

    const specialities = useAssignableSpecialities(selectedSpecialties === 'all' ? {} : { where: { uuid: { in: selectedSpecialties } } })
    const departmentUuids = Array.from(new Set(specialities.map(speciality => speciality.department_uuid).filter(Boolean)))
    const departments = useDepartments({
        where: { uuid: { in: departmentUuids } },
    })

    if (selectedSpecialties === 'all') {
        return { status: 'all' }
    }

    const [department] = departments
    if (departmentUuids.length === 1 && department !== undefined) {
        return { status: 'resolved', department, specialities }
    }

    if (departmentUuids.length > 1) {
        return { status: 'invalid', departments }
    }

    return { status: 'none' }
}
